module.exports = __webpack_public_path__ + "static/media/close.2fe1eb78.svg";